import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, shadow, control } = theme.tokens;
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      minWidth: 0
    },
    stage: {
      position: "relative",
      minWidth: 0
    },
    // 2 banners + a slice of the 3rd so it's obvious the row scrolls
    // (doubled selector so it beats GRail's kind class whatever the sheet order)
    peek: {
      "&&": {
        gridAutoColumns: "max(300px, calc((100% - 32px) / 2.12))",
        [theme.media.phone]: { gridAutoColumns: "86%" }
      }
    },
    banner: {
      display: "block",
      borderRadius: radius.card,
      overflow: "hidden",
      backgroundColor: color.surface
    },
    image: {
      display: "block",
      width: "100%",
      height: "auto",
      aspectRatio: "1025 / 341",
      objectFit: "cover",
      transition: "transform .3s ease"
    },
    nav: {
      appearance: "none",
      border: 0,
      cursor: "pointer",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: control.icon + 4,
      height: control.icon + 4,
      borderRadius: radius.pill,
      backgroundColor: color.bg,
      color: color.ink,
      boxShadow: shadow.float,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
      transition: "background-color .15s ease",
      "&:focus-visible": { outline: `2px solid ${color.brand}` },
      [theme.media.phone]: { display: "none" }
    },
    navPrev: { left: 12 },
    navNext: { right: 12 },
    dots: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 6
    },
    dot: {
      appearance: "none",
      border: 0,
      padding: 0,
      cursor: "pointer",
      width: 8,
      height: 8,
      borderRadius: radius.pill,
      backgroundColor: color.lineStrong,
      transition: "width .2s ease, background-color .2s ease",
      "&:focus-visible": { outline: `2px solid ${color.brand}` }
    },
    dotActive: {
      width: 22,
      backgroundColor: color.ink
    },
    // hover effects go last: JSS resolves $refs only to classes defined above
    [theme.media.hover]: {
      banner: { "&:hover $image": { transform: "scale(1.02)" } },
      nav: { "&:hover": { backgroundColor: color.field } },
      dot: { "&:hover": { backgroundColor: color.muted } },
      dotActive: { "&:hover": { backgroundColor: color.ink } }
    }
  };
});

export default withCustomStyles;
